import {
  GET_INDUSTRY_TAX_CARD_SUCCESS,
  LOCATION_CHANGE,
  GO_TO_RIMINDER,
  SHIPBUILDING_INDUSTRY_TAX_CARD_SUCCESS,
  SHIPBUILDING_INDUSTRY_TAX_CARD_FAILED,
  CLOSE_SNACKBAR,
  CLEAR_SELECTED_USER
} from '../constants'

/**
 * @author Huong Nguyen
 */

const taxAreaReducer = (
  state = {
    taxInfo: [],
    formValues: [],
    isSnackbar: false,
    isFailedSnackbar: false
  },
  action
) => {
  switch (action.type) {
    case GET_INDUSTRY_TAX_CARD_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          taxInfo: action.data
        }
      )

    case GO_TO_RIMINDER:
      return Object.assign(
        {},
        { ...state },
        {
          formValues: action.formValues
        }
      )

    case SHIPBUILDING_INDUSTRY_TAX_CARD_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          isSnackbar: true,
          isFailedSnackbar: false
        }
      )

    case SHIPBUILDING_INDUSTRY_TAX_CARD_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          isFailedSnackbar: true,
          isSnackbar: false
        }
      )

    case CLOSE_SNACKBAR:
      return Object.assign(
        {},
        { ...state },
        {
          isSnackbar: false,
          isFailedSnackbar: false
        }
      )

    case LOCATION_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          isSnackbar: false,
          isFailedSnackbar: false,
          taxInfo: []
        }
      )
    // PI-301 Clear Valtticard when search for new user email
    case CLEAR_SELECTED_USER:
      return Object.assign(
        {},
        { ...state },
        {
          taxInfo: []
        }
      )

    default:
      return state
  }
}

export default taxAreaReducer
